export const EmptyList = ({ label="Empty" } ) => (
  <li className="block hover:bg-gray-50">
    <div className="flex place-content-center px-4 py-4 sm:px-6">
      <h3 className="text-gray-500">{label}</h3>
    </div>
  </li>
)
